<template>
  <div class="empreendiments_cards">
    <ul class="row justify-content-center">
      <li class="col-lg-4 col-md-6 col-12" v-for="(item,index) in empreendimentos" :key="index">
        <router-link :to="{name: 'InternaApresentacao', params: {slug: item.slug}}">
          <div class="empreendiments_cards__box ui-image--cover" :style="'background-image: url(' + item.image + ');'">
            <div class="empreendiments_cards__hover_itens">
              <div class="row">
                <span v-for="(tag, index) in item.tags" :style="'background-color:'+tag.color" :key="index">
                  {{tag.name}}
                </span>
              </div>
            </div>
            <div class="box__titles ui-image--cover">
              <div class="box__titles__item">
                <h2 class="box__titles__title">
                  {{item.title}}
                </h2>
                <div class="box__titles__location">
                  {{item.neighborhood}}
                </div>
                <div class="row">
                  <div class="col-6" v-for="(characteristic, index) in item.main_characteristics" :key="index">
                    <div class="box__titles__info">
                      <img v-if="characteristic.image" :src="characteristic.image" :alt="characteristic.title"> <span>{{characteristic.title}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['empreendimentos']
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.empreendiments_cards {
  li {
    margin-bottom: 30px;
  }
  &__box {
    border-radius: 10px;
    box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
    height: 600px;
    overflow: hidden;
    padding: 20px;
    position: relative;
    transition: all 0.3s;
    &:before {
      background: url(../assets/img/know_more.png);
      content: '';
      height: 82px;
      left: calc(50% - 41px);
      opacity: 0;
      position: absolute;
      top: calc(50% - 41px);
      transition: all 0.3s;
      width: 82px;
    }
    &:hover {
      .empreendiments_cards__hover_itens {
        opacity: 1;
        transition: all 0.3s;
      }
      &:before {
        opacity: 1;
        transition: all 0.3s;
      }
    }
  }
  &__hover_itens {
    opacity: 0;
    transition: all 0.3s;
    span {
      background: $primary;
      border-radius: 10px;
      color: white;
      font-size: 14px;
      font-style: italic;
      font-weight: 300;
      margin: 0 5px;
      padding: 5px 10px;
      margin-bottom: 10px;
    }
  }
  .box__titles {
    position: absolute;
    background-image: url(../assets/img/bg_empreendiments.png);
    bottom: 0px;
    left: 0px;
    min-height: 269px;
    padding: 20px;
    width: 100%;
    &__title {
      color: white;
      font-size: 26px;
      font-weight: 900;
      margin-bottom: 5px;
      text-transform: uppercase;
      word-wrap: break-word;
    }
    &__location {
      color: #bababd;
      font-size: 18px;
      margin-bottom: 10px;
    }
    &__info {
      display: flex;
      align-items: center;
      font-style: italic;
      img {
        padding-right: 10px;
        max-width: 48px;
        max-height: 48px;
        margin-right: 5px;
        filter: invert(100%);
        @media (max-width: 400px) {
          max-width: 40px;
        }
      }
      span {
        color: white;
        font-size: 15px;
        font-style: italic;
        font-weight: 300;
        line-height: 20px;
      }
    }
    &__item {
      position: absolute;
      bottom: 20px;
      left: 20px;
      width: calc(100% - 40px);
    }
  }
  @media (max-width: 1400px){
    &__box {
      height: 450px;
    }
    .box__titles {
      &__title {
        font-size: 23px;
      }
      &__info {
        font-size: 14px;
        img {
          margin-top: -3px;
          margin-right: 0px;
        }
      }
    }
  }
  @media (max-width: 767px){
    overflow: hidden;
    padding-left: 0px;
    padding-right: 0px;
    .box__titles {
      &__info {
        margin-top: 10px;
        span {
          font-size: 14px;
        }
      }
    }
    &__box {
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeEmpreendimentosCard.vue